import React, { createContext } from "react";
import { WebAPIClient } from "@skygear/web";
import { ApolloProvider } from "@apollo/react-hooks";

import { APIClient } from "../api/APIClient";

export const ServiceContext = createContext<APIClient<WebAPIClient>>(
  null as any
);

interface ServiceContextProps {
  value: APIClient<WebAPIClient>;
}
export const ServiceContextProvider: React.FC<ServiceContextProps> = props => {
  return (
    <ServiceContext.Provider value={props.value}>
      <ApolloProvider client={props.value.apolloClient}>
        {props.children}
      </ApolloProvider>
    </ServiceContext.Provider>
  );
};
